module.exports = __webpack_public_path__ + "img/tik_no.8a4d60f5.png";